import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./inicio.scss";

export default function Inicio() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    // Reiniciar y reproducir cada vez que el componente se monta
    video.currentTime = 0;
    video.play().catch(() => {
      // Autoplay bloqueado por el navegador, al menos mostrar primer frame
      video.currentTime = 0;
    });
  }, []);

  return (
    <div className="inicio-container">
      <div className="hero section banner">
        {/* Ondas animadas de fondo */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `
                  radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 75% 75%, rgba(71, 85, 105, 0.15) 0%, transparent 50%),
                  radial-gradient(circle at 50% 50%, rgba(100, 116, 139, 0.1) 0%, transparent 50%)
                `,
            zIndex: 1,
          }}
        />

        {/* Patrón geométrico animado */}
        <div
          style={{
            position: "absolute",
            top: "-50%",
            left: "-50%",
            width: "200%",
            height: "200%",
            backgroundImage: `
                  linear-gradient(45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(-45deg, rgba(255, 255, 255, 0.03) 25%, transparent 25%),
                  linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%),
                  linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.03) 75%)
                `,
            backgroundSize: "60px 60px",
            backgroundPosition: "0 0, 0 30px, 30px -30px, -30px 0px",
            animation: "patternFloat 20s linear infinite",
            zIndex: 2,
          }}
        />

        {/* Overlay principal con textura */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: `
                  linear-gradient(135deg, 
                    rgba(71, 85, 105, 0.85) 0%, 
                    rgba(100, 116, 139, 0.75) 25%,
                    rgba(51, 65, 85, 0.8) 50%,
                    rgba(148, 163, 184, 0.7) 75%,
                    rgba(71, 85, 105, 0.85) 100%
                  )
                `,
            backdropFilter: "blur(1px)",
            zIndex: 3,
          }}
        />

        {/* Contenido principal */}
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            zIndex: 4,
            padding: "60px 0",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "55%",
              height: "auto",
              position: "relative",
              overflow: "visible",
            }}
          >
            <video
              ref={videoRef}
              autoPlay
              muted
              loop={false}
              playsInline
              style={{
                width: "1600px",
                height: "auto",
                objectFit: "contain",
                opacity: 0,
                transform: "translateY(20px)",
                animation: "scaleIn 1s ease-out 0.3s forwards",
              }}
            >
              <source
                src="/assets/portal/img/logo_banner.webm"
                type="video/webm"
              />
              {/* Fallback para navegadores que no soporten webm */}
              <img
                src="/assets/img/logo-cofolp.png"
                alt="Logo COFOLP"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "100%",
                  maxHeight: "280px",
                  objectFit: "contain",
                }}
              />
            </video>
          </div>
        </div>
        <div className="banner-text">
          <div className="banner-subtitle">
            <div className="banner-subtitle-text">
              El respaldo de la Fonoaudiología en La Pampa
              <span>Regulación • Formación • Ética</span>
            </div>
          </div>
        </div>
      </div>

      <div className="featured-services">
        <div className="deco1" />
        <div className="deco2" />
        <div className="container">
          <div className="row gy-4 justify-content-center">
            {/* Servicio 1: Acceso a AUTOGESTION */}
            <div className="col-lg-4 col-md-6 fade-up fade-up-1">
              <div
                className="svc-card svc-card--cyan"
                onClick={() => navigate("/login")}
              >
                <div className="svc-card__deco" />
                <div className="svc-card__icon">
                  <i className="fas fa-laptop-code"></i>
                </div>
                <h4 className="svc-card__title">Acceso a AUTOGESTION</h4>
                <p className="svc-card__desc">
                  Gestione sus trámites, consulte su estado de cuenta y acceda a
                  todos los servicios digitales del colegio.
                </p>
                <span className="svc-card__cta">Ingresar Ahora →</span>
              </div>
            </div>

            {/* Servicio 2: Buscar Fonoaudiólogo */}
            <div className="col-lg-4 col-md-6 fade-up fade-up-2">
              <div
                className="svc-card svc-card--green"
                onClick={() => navigate("../profesionales")}
              >
                <div className="svc-card__deco" />
                <div className="svc-card__icon">
                  <i className="fas fa-user-md"></i>
                </div>
                <h4 className="svc-card__title">Buscar Fonoaudiólogo</h4>
                <p className="svc-card__desc">
                  Encuentre profesionales matriculados por especialidad,
                  localidad y cobertura de obra social.
                </p>
                <span className="svc-card__cta">Buscar Ahora →</span>
              </div>
            </div>

            {/* Servicio 3: Próximos Cursos y Eventos */}
            <div className="col-lg-4 col-md-6 fade-up fade-up-3">
              <div
                className="svc-card svc-card--amber"
                onClick={() => navigate("../eventos")}
              >
                <div className="svc-card__deco" />
                <div className="svc-card__icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <h4 className="svc-card__title">Próximos Cursos y Eventos</h4>
                <p className="svc-card__desc">
                  Manténgase actualizado con las últimas capacitaciones,
                  workshops y eventos del colegio.
                </p>
                <span className="svc-card__cta">Ver Eventos →</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
